import { resolveOverrideName } from "./name";

const NAME_OVERRIDE_KEY = "bitforge.spesen.nameOverride";
const LEGACY_EMPLOYEE_KEY = "bitforge.spesen.employee";
const DEV_MODE_KEY = "bitforge.spesen.devMode";

/** The name people typed before Google sign-in existed is no longer used. */
export function dropLegacyEmployeeName(): void {
  localStorage.removeItem(LEGACY_EMPLOYEE_KEY);
}

/**
 * The override name for `email`, or null if none is stored, it's in the old
 * unscoped format, or it belongs to a different account (see name.ts).
 */
export function getNameOverride(email: string): string | null {
  return resolveOverrideName(localStorage.getItem(NAME_OVERRIDE_KEY), email);
}

export function setNameOverride(email: string, name: string): void {
  localStorage.setItem(NAME_OVERRIDE_KEY, JSON.stringify({ email, name: name.trim() }));
}

export function clearNameOverride(): void {
  localStorage.removeItem(NAME_OVERRIDE_KEY);
}

export function getDevMode(): boolean {
  return localStorage.getItem(DEV_MODE_KEY) === "1";
}

export function setDevMode(on: boolean): void {
  if (on) localStorage.setItem(DEV_MODE_KEY, "1");
  else localStorage.removeItem(DEV_MODE_KEY);
}
